// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CgQJ","content":"styles_content__1hRsc","tableWrap":"styles_tableWrap__2NM3o"};